import { render, staticRenderFns } from "./InviraUserCrud.vue?vue&type=template&id=d4f8a01e"
import script from "./InviraUserCrud.vue?vue&type=script&lang=js"
export * from "./InviraUserCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports